import { Selector } from 'reselect'
import { networkGroup } from './utils'

import {
  RootState,
} from '../../../types/frontend/store_generic'

export const initialised: Selector<RootState, boolean> = state => state.system.initialised
export const persistedRouteParams: Selector<RootState, Record<string, Record<string, string>>> = state => state.system.persistedRouteParams

export const network = networkGroup('system', [
  'initialise',
])

export default {
  initialised,
  persistedRouteParams,
  network,
}